
import React from 'react';
import {DashboardContainer} from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import { Bar } from "react-chartjs-2";

import {CategoryScale, Chart, LinearScale, BarElement} from 'chart.js';
Chart.register(CategoryScale, LinearScale, BarElement);

const flatten_events = corp_events => {
  let events = [];
  Object.keys(corp_events).forEach(cusip => {
    Object.keys(corp_events[cusip]).forEach(ev_type => {
      events = events.concat(
        corp_events[cusip][ev_type].closed_items,
        corp_events[cusip][ev_type].pending_items);
    })
  });
  const cusips = {};
  events.forEach(event => {
    cusips[event.cusip] = event.size;
  })
  return {
    events,
    cusips,
  }
}

const toYYYYMMDD = date => {
  return sprintf("%04d-%02d-%02d", date.getFullYear(), date.getMonth() + 1, date.getDate());
}

const create_chart = events => {
  const labels = [];
  const values = [];

  let date = new Date();
  for(let i=0; i < 365; i++) {
    date.setDate(date.getDate() + 1);
    labels.push(date.toLocaleDateString());
    const event_date = toYYYYMMDD(date);
    let cash = 0.
    events.forEach(ev => {
      if (ev.date === event_date) {
        cash += ev.amt_usd * ev.size;
      }
    });
    values.push(cash);
  }

  const chart_data = {
    datasets: [
      {
        label: 'Projected Portfolio Income in the next 365 days',
        data: values,
        borderColor: '#212529',
        backgroundColor: '#212529',
      }
    ],
    labels,
  };
  const options = {
    scales: {
      y: {
        ticks: {
          callback: function(value, index, values) {
            return  Math.round(value).toLocaleString(
              'en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });
          }
        }
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  }

  return (<Bar
    options={options}
    data={chart_data}/>)
}
const PortfolioIncome = props => {
  const title = "Projected Portfolio Income in the next 365 days";
  const corp_events = props.corp_events;
  const { events } = flatten_events(corp_events);
  const div_events = events.filter(ev => ev.partition === "PENDING_DIVIDEND");
  return (
    <DashboardContainer
      client={props.client}
      title={title}>
      {create_chart(div_events)}
    </DashboardContainer>
  )
}

export {PortfolioIncome};
